import WatchListEntriesPage from './WatchListEntriesPage';

export default WatchListEntriesPage;


// WEBPACK FOOTER //
// ./src/features/watch-list-entry/pages/watch-list-entries-page/index.js